import {
  /*                                 */
  get_current_component,
  /*                                 */
  get_custom_elements_slots,
  /*                                                         */
  /*         */
} from "svelte/internal";
import { type Writable, writable } from "svelte/store";

export function useSlots<SLOTS extends Record<string, boolean>>(): Writable<SLOTS> {
  const component = get_current_component();

  const { host } = component.$$.root as { host: HTMLElement };

  const store = writable(get_custom_elements_slots(host));

  new MutationObserver(() => {
    store.set(get_custom_elements_slots(host));
  }).observe(host, { childList: true });

  return store;
}
